<template>
  <section class="image">
    <nio-image :src="imageSrc" @click="handleJump"></nio-image>
    <p class="description" v-if="config.attrs.description">
      {{ config.attrs.description }}
    </p>
  </section>
</template>

<script>
import Image from '@/components/ui/Image';

export default {
  components: {
    'nio-image': Image
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    imageSrc(){
      return this.config.attrs.src || '';
    }
  },
  mounted(){
  },
  methods: {
    handleJump(){
      const link = this.config.attrs.href;

      if (link){
        console.log('link-click');
        this.$emit('link-click', link, this.config);
      } else {
        this.$emit('image-click', this.imageSrc, this.config);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.image {

}
</style>